import { render, staticRenderFns } from "./ReportTzirosPerMonthPage.vue?vue&type=template&id=0bc12e02&scoped=true"
import script from "./ReportTzirosPerMonthPage.vue?vue&type=script&lang=js"
export * from "./ReportTzirosPerMonthPage.vue?vue&type=script&lang=js"
import style0 from "./ReportTzirosPerMonthPage.vue?vue&type=style&index=0&id=0bc12e02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc12e02",
  null
  
)

export default component.exports